export class CredentialRoutes
{
    static Home: string = '/';

    // AWS
    static AWSList: string = '/aws/list';
    static AWSNew: string = '/aws/new';
    static AWSCopy(id: string)
    {
        return `/aws/${id}/new`;
    }
    static AWSEdit(id: string)
    {
        return `/aws/${id}/edit`;
    }
    static AWSView(id: string)
    {
        return `/aws/${id}/view`;
    }

    // Azure
    static AzureList: string = '/azure/list';
    static AzureNew: string = '/azure/new';
    static AzureCopy(id: string)
    {
        return `/azure/${id}/new`;
    }
    static AzureEdit(id: string)
    {
        return `/azure/${id}/edit`;
    }
    static AzureView(id: string)
    {
        return `/azure/${id}/view`;
    }

    // Basic Auth
    static BasicAuthList: string = '/basic/auth/list';
    static BasicAuthNew: string = '/basic/auth/new';
    static BasicAuthCopy(id: string)
    {
        return `/basic/auth/${id}/new`;
    }
    static BasicAuthEdit(id: string)
    {
        return `/basic/auth/${id}/edit`;
    }
    static BasicAuthView(id: string)
    {
        return `/basic/auth/${id}/view`;
    }

    // Database
    static DatabaseList: string = '/database/list';
    static DatabaseNew: string = '/database/new';
    static DatabaseCopy(id: string)
    {
        return `/database/${id}/new`;
    }
    static DatabaseEdit(id: string)
    {
        return `/database/${id}/edit`;
    }
    static DatabaseView(id: string)
    {
        return `/database/${id}/view`;
    }

    // GCP
    static GCPList: string = '/gcp/list';
    static GCPNew: string = '/gcp/new';
    static GCPCopy(id: string)
    {
        return `/gcp/${id}/new`;
    }
    static GCPEdit(id: string)
    {
        return `/gcp/${id}/edit`;
    }
    static GCPView(id: string)
    {
        return `/gcp/${id}/view`;
    }

    // GitHub
    static GitHubList: string = '/github/list';
    static GitHubNew: string = '/github/new';
    static GitHubCopy(id: string)
    {
        return `/github/${id}/new`;
    }
    static GitHubEdit(id: string)
    {
        return `/github/${id}/edit`;
    }
    static GitHubView(id: string)
    {
        return `/github/${id}/view`;
    }

    // GitLab
    static GitLabList: string = '/gitlab/list';
    static GitLabNew: string = '/gitlab/new';
    static GitLabCopy(id: string)
    {
        return `/gitlab/${id}/new`;
    }
    static GitLabEdit(id: string)
    {
        return `/gitlab/${id}/edit`;
    }
    static GitLabView(id: string)
    {
        return `/gitlab/${id}/view`;
    }

    // Token Auth
    static TokenAuthList: string = '/token/auth/list';
    static TokenAuthNew: string = '/token/auth/new';
    static TokenAuthCopy(id: string)
    {
        return `/token/auth/${id}/new`;
    }
    static TokenAuthEdit(id: string)
    {
        return `/token/auth/${id}/edit`;
    }
    static TokenAuthView(id: string)
    {
        return `/token/auth/${id}/view`;
    }

    // Host Basic Auth
    static HostBasicAuthList: string = '/host/basic/auth/list';
    static HostBasicAuthNew: string = '/host/basic/auth/new';
    static HostBasicAuthCopy(id: string)
    {
        return `/host/basic/auth/${id}/new`;
    }
    static HostBasicAuthEdit(id: string)
    {
        return `/host/basic/auth/${id}/edit`;
    }
    static HostBasicAuthView(id: string)
    {
        return `/host/basic/auth/${id}/view`;
    }

    // Host Token Auth
    static HostTokenAuthList: string = '/host/token/auth/list';
    static HostTokenAuthNew: string = '/host/token/auth/new';
    static HostTokenAuthCopy(id: string)
    {
        return `/host/token/auth/${id}/new`;
    }
    static HostTokenAuthEdit(id: string)
    {
        return `/host/token/auth/${id}/edit`;
    }
    static HostTokenAuthView(id: string)
    {
        return `/host/token/auth/${id}/view`;
    }

    // SSH
    static SSHList: string = '/ssh/list';
    static SSHNew: string = '/ssh/new';
    static SSHCopy(id: string)
    {
        return `/ssh/${id}/new`;
    }
    static SSHEdit(id: string)
    {
        return `/ssh/${id}/edit`;
    }
    static SSHView(id: string)
    {
        return `/ssh/${id}/view`;
    }
}